export enum HireButtonLabelEnum {
  HIRE = 'Contratar',
  MASTER_EXCLUSIVE = 'Contratação exclusiva ao titular da conta',
  ALREADY_HIRED = 'Seguro já solicitado',
  NOT_AVAILABLE = 'Serviço indisponível no momento',
}
